import "./styles.css";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import Button from "../Button/Button";
import { useUID } from "../../context/UIDContext";
import { useAmplitude } from "../../context/AmplitudeContext";

export const NameForm = ({ updateUserInfo }) => {
  const { t } = useTranslation("questionsModule");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const { uid } = useUID();
  const trackEvent = useAmplitude();

  useEffect(() => {
    trackEvent("webapp_user_visited_name_form_page", uid);
  }, [uid, trackEvent]);

  return (
    <>
      <div className="question-module-header">
        <h4 className="name-form-title">{t("name-form-title")}</h4>
        <p className="name-form-info">{t("name-form-detail-detail")}</p>
      </div>
      <div className="question-module-input-wrapper spaced">
        <input
          type="text"
          placeholder={t("first-name-placeholder")}
          value={firstName}
          onChange={(e) => {
            if (e.target.value.length < 100) {
              setFirstName(e.target.value);
            }
          }}
          className="name-form-input-field"
        />
        <input
          type="text"
          placeholder={t("last-name-placeholder")}
          value={lastName}
          onChange={(e) => {
            if (e.target.value.length < 100) {
              setLastName(e.target.value);
            }
          }}
          className="name-form-input-field"
        />
      </div>
      <div className="question-module-btn-wrapper-bottom">
        <Button
          text={t("continue")}
          onClick={() => {
            updateUserInfo({ firstName: firstName, lastName: lastName });
          }}
          disabled={firstName.length < 1 || lastName.length < 1}
          alternateColor={true}
        />
      </div>
    </>
  );
};
